import React from "react";
import { CircleFlag } from "react-circle-flags";

export const SpanishFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="es"
    height="25"
  />
);
export const EnglishFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="gb"
    height="25"
  />
);
export const GermanFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="de"
    height="25"
  />
);
export const BosnianFlag = () => (
  <svg
    className="languageIcons blueTextRemoved"
    xmlns="http://www.w3.org/2000/svg"
    height="25"
    viewBox="0 0 512 512"
  >
    <mask id="a">
      <circle cx="256" cy="256" r="256" fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#ffda44"
        d="M0 0h445.3l33.9 255-33.9 257-323.7-134.3L0 66.8z"
      />
      <path fill="#0052b4" d="M0 66.8V512h445.4z" />
      <path fill="#0052b4" d="M445.3 0H512v512h-66.7z" />
      <path
        fill="#eee"
        d="m354.6 456-8.3 25.6h-26.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5 21.7-15.8h-26.8zm-55-55.4-8.3 25.5h-26.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5 21.7-15.8h-26.8zM244.4 345l-8.3 25.5h-26.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5 21.7-15.8h-26.8zm-55.1-55.7-8.3 25.5h-26.8l21.7 15.8-8.3 25.5 21.7-15.8L211 356l-8.3-25.5 21.7-15.8h-26.8zm-55.4-55.7-8.3 25.5H98.8l21.7 15.8-8.3 25.5 21.7-15.8 21.7 15.8-8.3-25.5L169 259h-26.8zM78.7 178l-8.3 25.5H43.6l21.7 15.8-8.3 25.5L78.7 229l21.7 15.8-8.3-25.5 21.7-15.8H87zm-55.2-55.7-8.3 25.5h-26.8l21.7 15.8L1.8 189l21.7-15.8L45.2 189l-8.3-25.5 21.7-15.8H31.8z"
      />
    </g>
  </svg>
);
export const FranceFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="fr"
    height="25"
  />
);
export const ItalianFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="it"
    height="25"
  />
);
export const TurkishFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="tr"
    height="25"
  />
);
export const ArabicFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="sa"
    height="25"
  />
);

export const SerbianFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="rs"
    height="25"
  />
);

export const CroatianFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="hr"
    height="25"
  />
);

export const MontenegroFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="me"
    height="25"
  />
);

export const AlbanianFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="al"
    height="25"
  />
);

export const SloveniaFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="si"
    height="25"
  />
);

export const DutchFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="nl"
    height="25"
  />
);

export const AustriaFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="at"
    height="25"
  />
);

export const AmericanFlag = () => (
  <CircleFlag
    className="languageIcons blueTextRemoved"
    countryCode="us"
    height="25"
  />
);
